import { LanguageOption } from '../components/header/header.model';

export const APP_LANGUAGES: readonly LanguageOption[] = [
    { code: 'en', label: 'English' },
    { code: 'de', label: 'Deutsch' }
] as const;
